import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const {
  endpoints: {
    company: { assignationsUsers: url },
  },
} = config

const getUrl = (assignation) => url.replace(':idCompany', assignation.operator.company).replace(':operatorId', assignation.operator.id)

/**
 * Add a new assignation to the operator company
 * @param {Object} data
 * @param {String} data.userId user to assign
 * @param {{comapany: String, id: String}} data.operator
 */
const add = (data) => axios.post(getUrl(data), data, { headers: getHeaders(true) })


/**
 * Delete user assigned to an operator
 * @param {Object} data
 * @param {String} data.userId user assigned
 * @param {{comapany: String, id: String}} data.operator
 */
const remove = (data) =>
  axios.delete(getUrl(data), {
    headers: getHeaders(true),
    params: { userId: data.userId, operatorIds: data.operatorIds.join(',') },
  })

export default { add, remove }
